export const convertFileSizeToMb = (
  convertableNumber: number,
  fractionDigits: number
) => {
  return Number((convertableNumber / (1024 * 1024)).toFixed(fractionDigits));
};
